import React from "react";
import moment from "moment";
import { formatTime, formatWrittenDayMonthYear } from "utilities";

interface Props {
  value: string
}

const ReadonlyDateTime = (props: Props) => {
  const momentValue = moment.utc(props.value);

  return <>{formatWrittenDayMonthYear(momentValue)} {formatTime(momentValue)}</>;
};

export default ReadonlyDateTime;